import { get, post } from "../common/apiClient";

const PATH = "/question-bank";

const getBundles = async (params = {}) => {
  const query = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== "") {
      query.set(key, value);
    }
  });

  return get(`${PATH}/bundles?${query.toString()}`);
};

const createDraftManual = async (body) => {
  return post(`${PATH}/draft/manual`, body);
};

const createDraftRandomCustom = async (body) => {
  return post(`${PATH}/draft/random-custom`, body);
};

const createDraftRandomStandard = async (body) => {
  return post(`${PATH}/draft/random-standard`, body);
};

export {
  getBundles,
  createDraftManual,
  createDraftRandomCustom,
  createDraftRandomStandard,
};
